import { HttpMethod, PagingQuery } from "~/extensions/api";
export class FindKeiyakushaCommand extends PagingQuery {
    constructor(model) {
        super(HttpMethod.Post, "user/admin/find");
        this.userCd = model.userCd ?? null;
        this.userName = model.userName;
        this.userKb = model.userKb?.value ?? null;
        this.buknCd = model.buknCd ?? null;
        this.buknName = model.buknName;
    }
    /** 契約者コード */
    userCd = null;
    /** 契約者名 */
    userName = "";
    /** 契約区分 */
    userKb = null;
    /** 物件コード */
    buknCd = null;
    /** 物件名 */
    buknName = "";
}
